<template>
	<div class="register">
		<NavBar :registerPage="true" />
		<v-main>
			<RegisterForm :provider="provider" />
		</v-main>
		<Footer />
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Footer from "@/components/authentication/Footer.vue";
import RegisterForm from "@/components/authentication/RegisterForm.vue";

export default {
	name: "register",
	components: {
		NavBar,
		Footer,
		RegisterForm
	},
	props: {
		provider: {
			default: false
		}
	}
};
</script>

<style scoped>
/*STICKY FOOTER*/
.register {
	display: flex;
	min-height: 100vh;
	flex-direction: column;
}
</style>